import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useGetSetting } from "../../../hooks/getSetting";
import { selectFloatingChatVisible } from "../../../store/selector";
import ACTIONS from "../../../store/action";
import { FloatingChatWidget } from "./FloatingChatWidget";

const MemoFloatingChatWidget = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isFeatureEnabled] = useGetSetting(["fe.show-ai-chat-bot"]);
  const isPanelVisible = useSelector(selectFloatingChatVisible);

  const aiChatBotPath = location.pathname.startsWith("/ai-chat-bot");

  useEffect(() => {
    if (aiChatBotPath) {
      dispatch(ACTIONS.setFloatingChatVisible(false));
      dispatch(ACTIONS.setFloatingChatHistory(null, []));
      dispatch(ACTIONS.setFloatingChatConversationId(null));
    }
  }, [aiChatBotPath]);

  const memoizedWidget = useMemo(() => {
    if (!isFeatureEnabled || aiChatBotPath) {
      return null;
    }

    return <FloatingChatWidget />;
  }, [isFeatureEnabled, aiChatBotPath, isPanelVisible]);

  return memoizedWidget;
};

export { MemoFloatingChatWidget };
